import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {lodash} from '../../common/utils';

/**
 * Transit-specific pagination controls.
 */
@Component({
  selector: 'app-transit-pagination',
  templateUrl: './transit-pagination.component.html',
  styleUrls: ['./transit-pagination.component.scss'],
  standalone: false
})
export class TransitPaginationComponent implements OnChanges {
  @Input() maxPerPage = 20;
  @Input() page: number = 1;
  @Input() totalItems: number = 0;
  @Input() maxSize: number = 10;

  @Output() pageChange = new EventEmitter<number>();

  pages: Pages = {
    start: this.page,
    end: this.page + this.maxSize
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.applyPages();
  }

  private applyPages() {
    const leftOffset = Math.floor(this.maxSize / 2);
    const rightOffset = this.maxSize % 2 === 0 ? leftOffset - 1 : leftOffset;
    var start = 0;
    var end = this.totalPages();

    if (this.page <= leftOffset) {
      // very beginning, no rotation -> [0..maxSize]
      end = this.maxSize;
    } else if (this.totalPages() - this.page < leftOffset) {
      // very end, no rotation -> [len-maxSize..len]
      start = Math.max(0, this.totalPages() - this.maxSize);
    } else {
      // rotate
      start = this.page - leftOffset - 1;
      end = this.page + rightOffset;
    }
    this.pages = {
      start: start + 1,
      end: Math.min(end, this.totalPages())
    };
  }

  moveToPage = (page: number) => {
    const clampedPage = Math.min(Math.max(1, page), this.totalPages());
    if (this.page != clampedPage) {
      this.page = clampedPage;
      this.pageChange.emit(clampedPage);
    }
    this.applyPages();
  };

  totalPages = (): number => Math.max(1, Math.ceil(this.totalItems / this.maxPerPage));

  pagesArray = (): number[] => lodash.range(this.pages.start, this.pages.end + 1, 1);

  isCurrentPage = (page: number) => this.page === page;

  isFirstPage = () => this.page === 1;

  isLastPage = () => this.page === this.totalPages();
}

interface Pages {
  start: number;
  end: number;
}
